/**
 * M.2 — NIPE tool: listSharePointDocs
 *
 * Read-only. Lists documents in the firm's SharePoint Online folder for
 * the current matter. Context callback is optional — if the SPA doesn't
 * have a SharePoint drive configured, the runner surfaces a friendly
 * "integration not available" message instead of throwing.
 */

import type { NipeTool } from './types';

export interface ListSharePointDocsContext {
  /** Optional. Some sessions have no SP drive (no portal Site connected). */
  listSharePointDocs?: (
    matterPath?: string,
  ) => Promise<Array<{ name: string; webUrl?: string; id?: string }>>;
}

export const listSharePointDocsTool: NipeTool<ListSharePointDocsContext> = {
  schema: {
    type: 'function',
    function: {
      name: 'listSharePointDocs',
      description:
        "List documents in the firm's SharePoint Online folder for the current matter. Read-only.",
      parameters: {
        type: 'object',
        properties: {
          matterPath: {
            type: 'string',
            description:
              'Optional matter-relative folder path. Defaults to the current matter root.',
          },
        },
        required: [],
      },
    },
  },
  mutatesRemote: false,
  requiresApproval: false,
  handler: async (args, ctx) => {
    if (!ctx.listSharePointDocs) {
      return { error: 'SharePoint integration not available in this session' };
    }
    const matterPath =
      typeof args.matterPath === 'string' ? args.matterPath : undefined;
    const docs = await ctx.listSharePointDocs(matterPath);
    return { documents: docs };
  },
};
